import colors from './colors'
import fontSize from './fontSize'
import mediaQuery from './mediaQuery'
import webkit from './webkit'

const styles = {
  colors,
  mediaQuery,
  fontSize,
  webkit,
}

export default styles

const A4_IN_PIXEL_X = 595
const A4_IN_PIXEL_Y = 842

export { A4_IN_PIXEL_X, A4_IN_PIXEL_Y }

export { default as colors } from './colors'
export { elevation, typo } from './cssStyles'
export { default as floatingBorder } from './floatingBorder'
export { default as mediaQuery } from './mediaQuery'
export { default as resetCSS } from './reset'
export { default as textEllipsis } from './textEllipsis'
export { default as zIndex } from './zIndex'
